import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const DashboardFiltersStyles = styled.div`
  /* 24px gap below the PageHeader divider — matches Dashboard / Services
     pages so the filters bar doesn't sit flush against the divider. */
  margin-top: ${({ theme }) => theme.spacing[24]};
  margin-bottom: 28px;

  .filters-card {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px;
    border: 1px solid rgba(0, 0, 0, 0.02);
    border-radius: ${({ theme }) => theme.radius[12]};
  }

  .filters-left {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
  }

  .filters-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: relative;
    min-width: 0;
  }

  .field-label {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-weight: 500;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  .select {
    height: 36px;
    padding: 0 12px;
    background: #fff;
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: 8px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-family: inherit;
    min-width: 200px;
    transition: border-color 0.12s;
  }
  .select:hover {
    border-color: ${({ theme }) => theme.colors.accent[500]};
  }
  .select-icon {
    color: ${({ theme }) => theme.colors.accent[500]};
    display: inline-flex;
  }
  .select-trigger {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }
  .select-caret {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    display: inline-flex;
  }

  .popover {
    position: absolute;
    z-index: 60;
    top: calc(100% + 4px);
    left: 0;
    background: #fff;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    border-radius: 10px;
    box-shadow: ${({ theme }) => theme.shadows.dropdown};
    padding: 6px;
    min-width: 220px;
  }
  .popover-opt {
    padding: 8px 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }
  .popover-opt:hover {
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[500]};
  }
  .popover-opt.is-active {
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[500]};
    font-weight: 500;
  }

  .custom-range {
    display: flex;
    gap: 12px;
    align-items: flex-end;
  }
  .date-input {
    height: 36px;
    padding: 0 10px;
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: 8px;
    font-family: inherit;
    font-size: 13px;
    background: #fff;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }
  .date-input:hover,
  .date-input:focus {
    border-color: ${({ theme }) => theme.colors.accent[500]};
    outline: none;
  }

  .seg {
    display: inline-flex;
    padding: 3px;
    background: ${({ theme }) => theme.colors.accent[50]};
    border-radius: 8px;
  }
  .seg-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    font-family: inherit;
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    border-radius: 6px;
    letter-spacing: 0.1px;
  }
  .seg-btn.is-active {
    background: #fff;
    color: ${({ theme }) => theme.colors.accent[500]};
    box-shadow: ${({ theme }) => theme.shadows.cardAlt};
  }

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: inherit;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.1px;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    background: #fff;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    transition: background 0.12s, color 0.12s, border-color 0.12s;
  }
  .btn:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[500]};
    border-color: ${({ theme }) => theme.colors.accent[500]};
  }
  .btn-sm {
    padding: 6px 10px;
    font-size: 12px;
  }
  .btn-ghost {
    border-color: transparent;
    background: transparent;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }
  .btn-ghost:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Stack the filter bar and let the selects fill the width on phones. Placed
     last so the overrides win over the base rules. */
  ${media.maxMobile`
    .filters-card {
      flex-direction: column;
      align-items: stretch;
    }
    .filters-left {
      width: 100%;
    }
    .field {
      width: 100%;
    }
    .select {
      min-width: 0;
      width: 100%;
    }
    .filters-right {
      justify-content: flex-end;
    }
  `}
`;
